<template>
  <div id="container" class="container">
    <!-- 图例 -->
    <div :id="id"></div>
  </div>

</template>

<script>
import G6 from '@antv/g6'

export default {
  props: {
    id: {
      type: String,
      required: false,
      default() {
        return 'mountNode-' + new Date() + ((Math.random() * 1000).toFixed(0) + '')
      }
    },
    G6_width: {
      type: Number
    },
    G6_height: {
      type: Number
    },
    graphData: {
      type: Object,
      required: true
    },
  },

  data() {
    return {
      graph: null,
      defaultWidth: 0,
      defaultHeight: 0
    }
  },

  watch: {
    graphData: {
      deep: true,
      handler(val) {
        // console.log('数据watch====',val)
        this.handleData(val)
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      // console.log('初始化图例=====1111')
      this.defaultWidth = document.getElementById('container').scrollWidth
      this.defaultHeight = document.getElementById('container').scrollHeight || 300

      // window.onresize = () => {
      //     this.defaultWidth =  document.getElementById('container').scrollWidth
      //     this.defaultHeight = document.getElementById('container').scrollHeight || 500
      //     this.initNode()
      // }
      this.initNode()
    })

  },

  beforeDestroy() {
    if (!this.graph) {
      return
    }
    this.graph.clear()
    this.graph.destroy()
    this.graph = null
  },

  methods: {

    // 初始化节点
    initNode() {
      G6.registerNode(
        'sql',
        {
          drawShape(cfg, group) {
            const rect = group.addShape('rect', {
              attrs: {
                x: -cfg.size[0] / 2,
                y: -cfg.size[1] / 2,
                width: cfg.size[0],
                height: cfg.size[1],
                stroke: cfg.style.stroke,
                fill: cfg.style.fill,
                lineWidth: 1,
              }
            });
            return rect
          }
        },
        'single-node'
      )

      // console.log('初始化节点====2222')

      this.initG6() // 初始化图例
    },

    // 初始化图例
    initG6() {
      const width = this.G6_width || this.defaultWidth
      const height = this.G6_height || this.defaultHeight


      // console.log('进入====')
      this.graph = new G6.Graph({
        container: document.getElementById(this.id),
        width: width,
        height: height,
        fitView: true, // 画布自适应
        autoPaint: true, // 视口变化时，自动重绘
        modes: {
          default: ['drag-canvas', 'zoom-canvas', 'click-select']
        },

        layout: {
          type: 'dagre',
          controlPoints: true,
        },

        defaultNode: {
          type: 'sql',
          // size: [160, 80],
          style: {
            fill: '#aecdf9',
            stroke: '#C2C8D5',
            lineWidth: 1,
          }
        },

        defaultEdge: {
          type: 'polyline',
          style: {
            radius: 20,
            offset: 45,
            endArrow:true,
            lineWidth: 1,
            stroke: '#C2C8D5',
          },
        },

        nodeStateStyles: {
          selected: {
            stroke: '#d9d9d9',
            fill: '#aecdf9',
          },
          highlight: {
            stroke: '#ff0000',
          }
        },
        edgeStateStyles: {
          highlight: {
            stroke: '#ff0000',
          }
        }
      });

      // console.log('画图====33333')
    },

    // 处理数据
    handleData(val) {
      // console.log('填充数据====4444', val)
      this.graph.data(val) // 读取数据
      this.graph.render() // 渲染图

    //   this.graph.on('node:contextmenu', function (evt) {
    //     //当前节点定位
    //     console.log(evt)
    //     alert("右键事件弹窗")
    //   });
    
    var _this = this;
    // dblclick
    this.graph.on('node:click', function (evt) {
      //当前节点定位
      _this.$emit('getnodetitle', {data:evt.item._cfg.model});
      
    });
    var _graph = this.graph;

      this.graph.on('node:mouseenter', function (e) {
        var item = e.item;
        _graph.setAutoPaint(false);
        _graph.getNodes().forEach(function (node) {
          _graph.clearItemStates(node);
          _graph.setItemState(node, 'dark', true);
        });
        _graph.setItemState(item, 'dark', false);
        _graph.setItemState(item, 'highlight', true);
        _graph.getEdges().forEach(function (edge) {
          if (edge.getSource() === item) {
            _graph.setItemState(edge.getTarget(), 'dark', false);
            _graph.setItemState(edge.getTarget(), 'highlight', true);
            _graph.setItemState(edge, 'highlight', true);
            edge.toFront();
          } else if (edge.getTarget() === item) {
            _graph.setItemState(edge.getSource(), 'dark', false);
            _graph.setItemState(edge.getSource(), 'highlight', true);
            _graph.setItemState(edge, 'highlight', true);
            edge.toFront();
          } else {
            _graph.setItemState(edge, 'highlight', false);
          }
        });
        _graph.paint();
        _graph.setAutoPaint(true);
      });
    }


  }
}
</script>

<style lang="scss" scoped>
.container {
  position: relative;
  width: 100%;
  height: 100%;
  .graph-popover {
    position: absolute;
    transform-origin: left center;
    z-index: 2001;
  }
}
</style>